// Components==============
import Button from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';
import { usePermission } from 'hooks/usePermission';
import { useTranslate } from 'hooks/useTranslate';
import { TrainingDetailsContext } from 'pages/Workspace/TrainingDetails/TrainingDetails';
import React, { useContext } from 'react';
import './DeleteModal.module.scss';
// =========================

export default function DeleteModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { handleDelete, subscribers } = useContext(TrainingDetailsContext);

  const translate = useTranslate();

  function handleClick() {
    setModalIsOpen(false);
    handleDelete();
  }

  const isStudent = usePermission(['Leerling', 'Leerling Portfolio']);

  const hasStudents = subscribers && subscribers?.length > 0 && !isStudent;

  return (
    <Modal setModalIsOpen={setModalIsOpen} size="medium">
      <div styleName="wrapper">
        <img src="/images/trash.svg" alt="trash" />
        <h1>
          {hasStudents
            ? translate('course.errors.delete-course-title')
            : translate('course.confirm.delete-course-title')}
        </h1>
        <p>
          {hasStudents
            ? translate('course.errors.delete-course')
            : translate('course.confirm.delete-course')}
        </p>
      </div>
      <div styleName="buttons-wrapper">
        <Button color="grey" onClick={() => setModalIsOpen(false)}>
          {translate('general.terms.cancel')}{' '}
        </Button>
        <Button color="red" inactive={hasStudents} onClick={handleClick}>
          {translate('general.terms.delete')}
        </Button>
      </div>
    </Modal>
  );
}
